import React, { useState, useEffect } from "react";
import "../styles/vehiclestock.css";


import { fetchVehicleStockList } from "../services/vehicleStockService";
import { getVehicleDetail } from "../services/vehicleStockDetailService";

function VehicleStock() {

  const [vehicles, setVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [currentImage, setCurrentImage] = useState(0);
  const [loading, setLoading] = useState(false);

  // ✅ LOAD VEHICLE LIST FROM API
  useEffect(() => {
    loadVehicles();
  }, []);

 const loadVehicles = async () => {
  try {
    const data = await fetchVehicleStockList();

    if (!Array.isArray(data)) {
      console.error("Invalid API response:", data);
      setVehicles([]);
      return;
    }

    setVehicles(data);
  } catch (err) {
    console.error(err);
    setVehicles([]);
  }
};

  // ✅ OPEN MODAL + FETCH DETAIL
  const openModal = async (vehicle) => {
    try {
      setLoading(true);

      const detail = await getVehicleDetail(vehicle.vehicle_id);

      setSelectedVehicle(detail);
      setCurrentImage(0);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setSelectedVehicle(null);
  };

  const nextImage = () => {
    if (!selectedVehicle?.photo_list) return;

    setCurrentImage((prev) =>
      (prev + 1) % selectedVehicle.photo_list.length
    );
  };

  const prevImage = () => {
    if (!selectedVehicle?.photo_list) return;

    setCurrentImage((prev) =>
      prev === 0
        ? selectedVehicle.photo_list.length - 1
        : prev - 1
    );
  };

  const getImageUrl = (url) => {
  if (!url) return "/No_Image_Available.jpeg";

  try {
    const imagePath = url.split(":8080/")[1];
    return `/vehicle-images/${imagePath}`;
  } catch {
    return "/No_Image_Available.jpeg";
  }
};


  return (
    <div className="vehicle-stock-page">
      

      <div className="stock-container">

        {/* GRID */}
        <div className="stock-grid">
          {vehicles.length === 0 && <p>No vehicles found</p>}

          {vehicles.map((v) => {
  const fileUrl = v.photo_url
    ? v.photo_url.replace("https://", "http://")
    : "/No_Image_Available.jpeg";

  return (
    <div
      key={v.vehicle_id}
      className="stock-card"
      onClick={() => openModal(v)}
    >
     <img
  src={getImageUrl(v.photo_url)}
  alt="vehicle"
  onError={(e) => {
    e.target.src = "/No_Image_Available.jpeg";
  }}
/>

      <div className="stock-info">
        <h3>
          {v.vehicle_make} {v.vehicle_model}
        </h3>

        <p>
          <strong>Price:</strong>{" "}
          {v.selling_price
            ? `LKR ${Number(v.selling_price).toLocaleString()}`
            : "Not Available"}
        </p>
      </div>
    </div>
  );
})}
        </div>

        {/* MODAL */}
        {selectedVehicle && (
          <div className="stock-modal-overlay" onClick={closeModal}>

            <div
              className="stock-modal"
              onClick={(e) => e.stopPropagation()}
            >

              <button className="close-btn" onClick={closeModal}>✕</button>

              {/* IMAGE VIEWER */}
              <div className="image-viewer">

                <button className="nav-btn left" onClick={prevImage}>❮</button>

                

              <img
  src={getImageUrl(
    selectedVehicle.photo_list?.[currentImage]?.url
  )}
  alt="vehicle-large"
  onError={(e) => {
    e.target.src = "/No_Image_Available.jpeg";
  }}
/>
                <button className="nav-btn right" onClick={nextImage}>❯</button>

              </div>

              {/* DETAILS */}
              <div className="stock-details">

                <h2>
                  {selectedVehicle.vehicle_make}{" "}
                  {selectedVehicle.vehicle_model}
                </h2>

                <div className="details-grid">

                  <div>
                    <label>Chassis</label>
                    <span>{selectedVehicle.chassis_no}</span>
                  </div>

                  <div>
                    <label>Price</label>
                    <span>
                      {selectedVehicle.selling_price ?? "Not Available"}
                    </span>
                  </div>

                </div>

              </div>

            </div>
          </div>
        )}

        {/* OPTIONAL LOADING */}
        {loading && <div className="loading">Loading...</div>}

      </div>
    </div>
  );
}

export default VehicleStock;